import { all, fork } from "redux-saga/effects";
import codeManagement from "./codeManagement";
import paperRegistrationStatus from "./paper-registration-status";
import user from "./user";

export default function* rootSaga() {
  yield all([fork(user), fork(codeManagement), fork(paperRegistrationStatus)]);
}
